(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/team/assets/javascripts/team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/team/assets/javascripts/team.js');
"use strict";

const {
  useEffect,
  useRef
} = React;
const {
  Link,
  useLocation
} = ReactRouterDOM;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  unwrapResult
} = RTK;
const ReactButton = svs.ui.ReactButton;
const {
  Members
} = svs.components.marketplaceCompetition.team;
const {
  deleteTeam
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  useHistory,
  useRouteMatch
} = ReactRouterDOM;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetition
} = svs.components.marketplaceCompetition.services.hooks;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  selectTeams
} = svs.components.marketplaceCompetition.services.selectors;
const logger = svs.core.log.getLogger('marketplace-competition:team');
const {
  fetchTeams,
  leaveTeam: onLeaveTeam
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const {
  Loader
} = svs.components.ReactLoader;
const {
  processErrorCode
} = svs.components.marketplaceShared.competitionErrorCodes;
const {
  useIsBeforeSignupStartTime,
  useIsBeforeSignupEndTime
} = svs.components.marketplaceCompetition.team.useCompetitionSignupTime;
const Team = _ref => {
  var _teamResult$data;
  let {
    currentTeamId,
    teamResult
  } = _ref;
  const dispatch = useDispatch();
  const competitionId = useCompetitionId();
  const competition = useCompetition(competitionId);
  const {
    data: teams,
    status: teamsStatus
  } = useSelector(state => selectTeams(state, competitionId));
  const {
    params
  } = useRouteMatch();
  const history = useHistory();
  const isDismounted = useRef(false);
  const location = useLocation();
  const fromJoin = useRef(location.search.includes('fromJoin=true'));
  const teamId = currentTeamId || parseInt(params.teamId, 10);
  const currentTeamObject = teams ? teams[teamId] || {} : {};
  const currentTeam = currentTeamObject.data ? currentTeamObject.data : {};
  const members = currentTeam.members || [];
  const currentUser = members.find(member => member.isCurrentMember) || {};
  const hasReachedMaxMembers = members.length === currentTeam.maxNumMembers;
  const isBeforeSignupStartTime = useIsBeforeSignupStartTime({
    competition
  });
  const isBeforeSignupEndTime = useIsBeforeSignupEndTime({
    competition
  });
  const isWithinSignupTime = !isBeforeSignupStartTime && isBeforeSignupEndTime;
  const hasAnyMemberPlayed = teamResult === null || teamResult === void 0 || (_teamResult$data = teamResult.data) === null || _teamResult$data === void 0 || (_teamResult$data = _teamResult$data.drawResults) === null || _teamResult$data === void 0 ? void 0 : _teamResult$data.some(drawResult => {
    var _drawResult$contribut;
    return drawResult === null || drawResult === void 0 || (_drawResult$contribut = drawResult.contributions) === null || _drawResult$contribut === void 0 ? void 0 : _drawResult$contribut.some(contribution => contribution === null || contribution === void 0 ? void 0 : contribution.hasPlayed);
  });
  const hasRemoveButton = isWithinSignupTime && !hasAnyMemberPlayed && currentUser.isTeamOwner;
  const hasLeaveBtn = isBeforeSignupEndTime && !hasAnyMemberPlayed && !currentUser.isTeamOwner;
  const hasInviteBtn = isWithinSignupTime && !hasReachedMaxMembers && !hasAnyMemberPlayed && currentUser.isTeamOwner;
  useEffect(() => {
    dispatch(fetchTeams(competitionId));
  }, [teams, competition, dispatch, competitionId]);
  const createDialog = (dialogTitle, dialogIcon, dialogBtnText, cb) => {
    dispatch(showDialogAction({
      title: dialogTitle,
      icon: dialogIcon,
      buttons: [{
        text: 'Avbryt'
      }, {
        text: dialogBtnText,
        callback: () => {
          svs.ui.loader.show();
          cb();
        }
      }]
    }));
  };
  const leaveTeam = member => {
    const dialogIcon = 'remove-sign';
    const dialogBtnText = 'Lämna laget';
    const dialogTitle = "Vill du l\xE4mna ".concat(currentTeam.name, "?");
    const cb = async () => {
      try {
        const resultAction = await dispatch(onLeaveTeam({
          competitionId,
          teamId: currentTeam.id,
          customerId: member.customerId,
          isCurrentMember: member.isCurrentMember
        }));
        const fullfilledPayload = unwrapResult(resultAction);
        if (fullfilledPayload) {
          svs.ui.loader.hide();
          if (member.isCurrentMember) {
            history.push("/tavlingar/".concat(params.competitionName));
          }
        }
      } catch (err) {
        const {
          errorTitle,
          errorMessage
        } = processErrorCode(err);
        svs.ui.loader.hide();
        logger.info("Mkp-competition: leave team error: ".concat(errorMessage));
        dispatch(showDialogAction({
          title: errorTitle,
          text: errorMessage,
          type: 'error',
          icon: 'exclamation-sign',
          buttons: [{
            text: 'Okej'
          }]
        }));
      }
    };
    createDialog(dialogTitle, dialogIcon, dialogBtnText, cb);
  };
  useEffect(() => {
    isDismounted.current = false;
    return () => {
      isDismounted.current = true;
    };
  });
  useEffect(() => {
    const onCantFind = () => {
      if (!isDismounted.current) {
        dispatch(showDialogAction({
          title: 'Vi kunde inte hitta laget just nu',
          text: 'Just nu har vi tekniska problem. Försök igen lite senare.',
          type: 'error',
          icon: 'exclamation-sign',
          buttons: [{
            text: 'Okej'
          }]
        }));
      }
    };
    if (!fromJoin.current) {
      if (teamId && teamsStatus === FetchState.Fulfilled && !(currentTeam !== null && currentTeam !== void 0 && currentTeam.members)) {
        history.push("/tavlingar/".concat(params.competitionName));
        onCantFind();
      } else if (teamId && teamsStatus === FetchState.Rejected) {
        history.push("/tavlingar/".concat(params.competitionName));
        onCantFind();
      }
    }
  }, [teamId, teamsStatus]);
  const removeTeam = currentTeam => {
    const dialogTitle = "Vill du avsluta laget ".concat(currentTeam.name, "?");
    const cb = async () => {
      try {
        const resultAction = await dispatch(deleteTeam({
          competitionId,
          teamId: currentTeam.id
        }));
        const fullfilledPayload = unwrapResult(resultAction);
        if (fullfilledPayload) {
          history.push("/tavlingar/".concat(params.competitionName));
          svs.ui.loader.hide();
        }
      } catch (err) {
        const {
          errorTitle,
          errorMessage
        } = processErrorCode(err);
        svs.ui.loader.hide();
        logger.info("Mkp-competition: remove team error: ".concat(err));
        dispatch(showDialogAction({
          title: errorTitle,
          text: errorMessage,
          type: 'error',
          icon: 'exclamation-sign',
          buttons: [{
            text: 'Okej'
          }]
        }));
      }
    };
    createDialog(dialogTitle, 'dustbin', 'Ta bort', cb);
  };

  const renderTeamButtons = () => React.createElement("div", {
    className: "team-buttons"
  }, Boolean(hasInviteBtn) && React.createElement(ReactButton, {
    block: true,
    inverted: true,
    size: 300
  }, React.createElement(Link, {
    className: "qa-to-invite",
    "data-testid": "qa-goto-invitation",
    to: "/tavlingar/".concat(params.competitionName, "/lag/").concat(currentTeam.id, "/bjud-in")
  }, "Bjud in medlemmar")), Boolean(hasRemoveButton) && React.createElement(ReactButton, {
    block: true,
    "data-testid": "qa-delete-team",
    onClick: () => {
      removeTeam(currentTeam);
    },
    size: 300,
    transparent: true
  }, "Ta bort lag"), Boolean(hasLeaveBtn) && React.createElement(ReactButton, {
    block: true,
    "data-testid": "qa-leave-team",
    onClick: () => {
      leaveTeam(currentUser);
    },
    size: 300,
    transparent: true
  }, "L\xE4mna lag"));
  if (teamsStatus === FetchState.Pending) {
    return React.createElement("div", {
      className: "competition-team margin-top-2",
      "data-testid": "qa-competition-team-loading"
    }, React.createElement(Loader, {
      inverted: true
    }));
  }
  return React.createElement("div", {
    className: "competition-team",
    "data-testid": "qa-competition-team"
  }, React.createElement(Members, {
    competition: competition,
    currentTeam: currentTeam,
    currentUser: currentUser,
    teamResult: teamResult
  }), (hasRemoveButton || hasLeaveBtn || hasInviteBtn) && renderTeamButtons());
};
setGlobal('svs.components.marketplaceCompetition.team.Team', Team);

 })(window);